import React from "react";
// External dependencies
import { Link } from "react-router-dom";
// Internal dependencies
import { handleDropdownClick } from "../../../utils/functions/handleDropdownClick";
// Css files
import "./ShortCutKeyBar.css";

const ShortcutKeyBar = ({ isShortCutKey, setDropdownState }) => {
  const shortcuts = [
    { key: "F1", description: "Help" },
    { key: "F2", description: "Dashboard" },
    { key: "F3", description: "New Invoice" },
    { key: "F4", description: "New Estimate" },
    { key: "F6", description: "New Supplier Bill" },
    { key: "F7", description: "New Product" },
    { key: "F8", description: "New POS" },
    { key: "F9", description: "New Customer" },
    { key: "F10", description: "New Supplier" },
    { key: "F11", description: "New Payment" },
    { key: "F12", description: "New Receipt" },
    { key: "CTRL+S", description: "Save" },
    { key: "ALT+C", description: "Cancel" },
    { key: "ALT+P", description: "Opening Stock" },
  ];
  return (
    <>
    {isShortCutKey&&<div
      className="header-overlay"
      onClick={() =>
        handleDropdownClick("", setDropdownState)
      }
      onContextMenu={() =>
        handleDropdownClick("", setDropdownState)
      }
    ></div>}
      <span
        onClick={() => handleDropdownClick("isShortCutKey", setDropdownState)}
        className="m-nav__link m-dropdown__toggle"
        title="HELP"
      >
        <span className="m-nav__link-icon">
          <i className="fa fa-question-circle"></i>
        </span>
      </span>
      <div
        id="shortcutkeybar_bar_header"
        className={`m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light card-body-sm ${
          isShortCutKey && "m-quick-sidebar--on"
        }`}
      >
        <div className="m-quick-sidebar__content1">
          <span
            id="m_quick_sidebar_close2"
            className="m-quick-sidebar__close"
            style={{ top: "10px" }}
            onClick={
              (() => handleDropdownClick(!isShortCutKey), setDropdownState)
            }
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </span>
          <div className="col-12 p-0">
            <table id="sidebar-menu" className="table mb-0">
              <tbody>
                {shortcuts.map((standardKey, index) => (
                  <tr key={index}>
                    <td>
                      <b>{standardKey.key}</b> - {standardKey.description}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td>
                    <Link to="https://qz.io/download/" target="_blank">
                      <b>Download QZ Tray</b>
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Link
                      to="https://www.vasyerp.com/rustdesk-host=rustdesk.vasyerp.com,key=Q+LAmN9CqqQ5d4wZHZ+R6sgi20pvOArCoqc1kYrg9s0=.exe"
                      target="_blank"
                    >
                      <b>Download RustDesk</b>
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Link
                      to="https://www.youtube.com/channel/UCihQetllwDVBBMUimNedYEw/playlists"
                      target="_blank"
                    >
                      <b>Help Videos</b>
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShortcutKeyBar;
